

export function Cards(props: { children: preact.ComponentChildren }) {
  return <div class="cards">{props.children}</div>
}

export function Card(props: { title: string, description: string, image: string, url: string }) {
  return <div class="card">
    <img src={props.image} alt={props.title} />
    <div className="content">
      <h3>{props.title}</h3>
      <p>{props.description}</p>
      <a href={props.url} class="arrow">Explore</a>
    </div>
  </div>
}

export function WideCard(props: preact.JSX.IntrinsicElements['div']) {
  return <div class="wide-card" {...props}>{props.children}</div>
}